import React, { createContext, useContext, useState, useCallback } from "react";

export const UI = {
  de: {
    nav: { products: "Produkte", tpu: "TPU", applications: "Anwendungen", industries: "Branchen", quality: "Qualität", logistics: "Logistik", knowledge: "Wissen", about: "Über uns", contact: "Kontakt", portal: "Kundenportal", downloads: "Downloads" },
    cta: { contact: "Kontakt aufnehmen", request: "Anfragen", details: "Technische Details", more: "Mehr dazu", sample: "Muster anfragen", offer: "Angebot anfordern", allProducts: "Alle Produkte", explore: "TPU entdecken", send: "Anfrage senden", portal: "Zum Kundenportal" },
    common: { availability: "Verfügbarkeit", onRequest: "Auf Anfrage", material: "Material", method: "Verarbeitung", hardness: "Härte", madeIn: "Made in Germany", faq: "Häufige Fragen" },
    kn: {
      hubTitle: "Wissens-Center für technische Kunststoffe",
      hubSubtitle: "Fundiertes, faktenbasiertes Material- und Verarbeitungswissen rund um TPU – über 25 Fachartikel für Verarbeiter, Einkäufer und Entwickler.",
      seoTitle: "Wissens-Center: TPU Ratgeber, Verarbeitung & Materialvergleiche | PlastoNord",
      seoDesc: "Über 25 Fachartikel rund um thermoplastisches Polyurethan (TPU): Grundlagen, Material-Vergleiche (TPU vs. TPE, PVC, Gummi, EVA, Silikon), Kennwerte (Shore, MFI), Verarbeitung (Extrusion, Spritzguss, 3D-Druck) und Recycling.",
      summary: "Kurzfassung",
      glance: "Auf einen Blick",
      faq: "Häufige Fragen",
      relatedProducts: "Passende Produkte",
      relatedArticles: "Weiterführende Artikel",
      moreFromHub: "Mehr aus dem Wissens-Center",
      note: "Hinweis:",
      advice: "Technische Beratung zu",
      adviceText: "Unser Team unterstützt Sie bei Materialauswahl, Härte und Verarbeitung",
      send: "Anfrage senden",
      home: "Home",
    },
  },
  en: {
    nav: { products: "Products", tpu: "TPU", applications: "Applications", industries: "Industries", quality: "Quality", logistics: "Logistics", knowledge: "Knowledge", about: "About", contact: "Contact", portal: "Customer Portal", downloads: "Downloads" },
    cta: { contact: "Get in touch", request: "Request", details: "Technical details", more: "Learn more", sample: "Request sample", offer: "Request quote", allProducts: "All products", explore: "Explore TPU", send: "Send inquiry", portal: "Open Customer Portal" },
    common: { availability: "Availability", onRequest: "On request", material: "Material", method: "Processing", hardness: "Hardness", madeIn: "Made in Germany", faq: "Frequently asked questions" },
    kn: {
      hubTitle: "Knowledge Center for technical plastics",
      hubSubtitle: "Sound, fact-based material and processing knowledge around TPU – over 25 technical articles for processors, buyers and developers.",
      seoTitle: "Knowledge Center: TPU guide, processing & material comparisons | PlastoNord",
      seoDesc: "Over 25 technical articles on thermoplastic polyurethane (TPU): fundamentals, material comparisons (TPU vs. TPE, PVC, rubber, EVA, silicone), properties (Shore, MFI), processing (extrusion, injection moulding, 3D printing) and recycling.",
      summary: "In brief",
      glance: "At a glance",
      faq: "Frequently asked questions",
      relatedProducts: "Suitable products",
      relatedArticles: "Further articles",
      moreFromHub: "More from the Knowledge Center",
      note: "Note:",
      advice: "Technical advice on",
      adviceText: "Our team supports you with material selection, hardness and processing",
      send: "Send inquiry",
      home: "Home",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("de");
  const toggle = useCallback(() => setLang((l) => (l === "de" ? "en" : "de")), []);
  const t = useCallback((path) => {
    const parts = path.split(".");
    let v = UI[lang];
    for (const p of parts) v = v?.[p];
    return v ?? path;
  }, [lang]);
  const pick = useCallback((obj) => (obj?.[lang] ?? obj?.de ?? ""), [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
